export function getPathValue(obj: Record<string, any>, path: string): any {
  return path.split('.')
    .reduce((o, prop) => (o && o[prop]) || null, obj);
}
